import { render, staticRenderFns } from "./StackedBarApex.vue?vue&type=template&id=d4c8ce4e"
import script from "./StackedBarApex.vue?vue&type=script&lang=js"
export * from "./StackedBarApex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports